module.exports = __webpack_public_path__ + "img/grand-cancun-room-3.350a0ea1.jpg";